import React, { useState, useEffect } from 'react';
import { getServicesAll, createService, updateService, deleteService } from '../api';

const empty = { icon: '💻', title: '', description: '', sort_order: 0, is_active: 1 };

const Modal = ({ title, onClose, children }) => (
  <div className="admin-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
    <div className="admin-modal">
      <div className="admin-modal-header">
        <h3>{title}</h3>
        <button className="admin-modal-close" onClick={onClose}>✕</button>
      </div>
      <div className="admin-modal-body">{children}</div>
    </div>
  </div>
);

const ServicesAdmin = () => {
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal]   = useState(null); // null | 'add' | 'edit'
  const [form, setForm]     = useState(empty);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState('');

  const load = async () => {
    setLoading(true);
    const res = await getServicesAll();
    if (res.success) setItems(res.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const openAdd  = () => { setForm(empty); setModal('add'); setMsg(''); };
  const openEdit = (s)  => { setForm({ ...s }); setModal('edit'); setMsg(''); };
  const closeModal = () => { setModal(null); setForm(empty); };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      const res = modal === 'add'
        ? await createService(form)
        : await updateService(form.id, form);
      if (res.success) { await load(); closeModal(); }
      else setMsg(res.message || 'Error saving.');
    } catch { setMsg('Network error.'); }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this service?')) return;
    await deleteService(id);
    await load();
  };

  const toggleActive = async (s) => {
    await updateService(s.id, { ...s, is_active: s.is_active ? 0 : 1 });
    await load();
  };

  return (
    <div>
      <div className="admin-section-header">
        <h2>🛠️ Services</h2>
        <button className="btn-admin-primary" onClick={openAdd}>+ Add Service</button>
      </div>

      {loading ? <p>Loading...</p> : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>#</th><th>Icon</th><th>Title</th><th>Description</th>
                <th>Order</th><th>Status</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((s, i) => (
                <tr key={s.id}>
                  <td>{i + 1}</td>
                  <td style={{ fontSize: '1.5rem' }}>{s.icon}</td>
                  <td style={{ fontWeight: 600 }}>{s.title}</td>
                  <td style={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.description}</td>
                  <td>{s.sort_order}</td>
                  <td>
                    <span className={`status-badge ${s.is_active ? 'status-active' : 'status-inactive'}`}>
                      {s.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div className="actions">
                      <button className="btn-admin-primary btn-admin-sm" onClick={() => openEdit(s)}>✏️ Edit</button>
                      <button className="btn-admin-primary btn-admin-sm" onClick={() => toggleActive(s)}
                        style={{ background: s.is_active ? '#f39c12' : '#28a745' }}>
                        {s.is_active ? '⏸ Hide' : '▶ Show'}
                      </button>
                      <button className="btn-admin-primary btn-admin-sm btn-admin-danger" onClick={() => handleDelete(s.id)}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={7} style={{ textAlign: 'center', color: '#adb5bd', padding: '40px' }}>No services yet. Add one!</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <Modal title={modal === 'add' ? '+ Add New Service' : '✏️ Edit Service'} onClose={closeModal}>
          {msg && <div style={{ background:'#ffebee', color:'#c62828', padding:'10px 14px', borderRadius:'8px', marginBottom:'14px', fontSize:'0.85rem' }}>❌ {msg}</div>}
          <form onSubmit={handleSave}>
            <div className="admin-form-row">
              <div className="admin-form-group">
                <label>Icon (emoji)</label>
                <input value={form.icon} onChange={e => setForm({ ...form, icon: e.target.value })} placeholder="💻" maxLength={5} />
              </div>
              <div className="admin-form-group">
                <label>Sort Order</label>
                <input type="number" value={form.sort_order} onChange={e => setForm({ ...form, sort_order: +e.target.value })} />
              </div>
            </div>
            <div className="admin-form-group">
              <label>Title *</label>
              <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="Service title" required />
            </div>
            <div className="admin-form-group">
              <label>Description *</label>
              <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Service description..." rows={4} required />
            </div>
            <div className="admin-form-group">
              <div className="admin-switch-row">
                <label className="admin-switch">
                  <input type="checkbox" checked={!!form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked ? 1 : 0 })} />
                  <span className="admin-slider"></span>
                </label>
                <span style={{ fontSize: '0.88rem', fontWeight: 600 }}>Active (show on website)</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button type="submit" className="btn-admin-primary" disabled={saving} style={{ flex: 1, justifyContent: 'center', padding: '12px' }}>
                {saving ? '⏳ Saving...' : '💾 Save Service'}
              </button>
              <button type="button" className="btn-admin-outline" onClick={closeModal}>Cancel</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
};

export default ServicesAdmin;
